import mergeImages from 'merge-images';

const generateTransparentKitty = async (kitty) => {
  const fur = kitty.attributes.filter((attr) => attr.trait_type === 'Fur')[0];
  const eyes = kitty.attributes.filter((attr) => attr.trait_type === 'Eyes')[0];
  const whiskers = kitty.attributes.filter((attr) => attr.trait_type === 'Whiskers')[0];
  const mouth = kitty.attributes.filter((attr) => attr.trait_type === 'Mouth')[0];
  const clothes =
    kitty.attributes.filter((attr) => attr.trait_type === 'Clothing')[0] || kitty.attributes.filter((attr) => attr.trait_type === 'Clothes')[0];
  const head = kitty.attributes.filter((attr) => attr.trait_type === 'Head')[0];
  const accessory = kitty.attributes.filter((attr) => attr.trait_type === 'Accessory')[0];

  let gen = 'third-litter';
  if (kitty.gen === 4) {
    gen = 'fourth-litter';
  } else if (kitty.gen === 1) {
    gen = 'first-litter';
  } else if (kitty.gen === 2) {
    gen = 'second-litter';
  }

  const positions = {
    x: 0,
    y: 0,
  };

  const createImageLayer = (trait, traitType, condition = true) => {
    if (!condition || !trait) return [];
    return [
      {
        src: `/${gen}/traits/${traitType}/${trait.value.replace('#', '')}.png`,
        ...positions,
      },
    ];
  };

  const images = [
    ...createImageLayer(accessory, 'accessories', gen === 'second-litter'),
    ...createImageLayer(fur, 'furs'),
    ...createImageLayer(whiskers, 'whiskers'),
    ...createImageLayer(mouth, 'mouthes'),
    {
      src: `/${gen}/traits/${gen === 'second-litter' ? 'clothes' : 'clothing'}/${clothes.value}.png`,
      ...positions,
    },
    ...createImageLayer(eyes, 'eyes'),
    ...createImageLayer(accessory, 'accessories', gen !== 'second-litter'),
    ...createImageLayer(head, 'heads'),
  ];

  const b64 = await mergeImages(images, {
    width: 3000,
    height: 3000,
  });

  return b64;
};

export default generateTransparentKitty;
